var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRegistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1580"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 18.5,
    cy: 18.5,
    r: 18,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 18C18.1062 18 17.3411 17.6818 16.7047 17.0453C16.0682 16.4089 15.75 15.6437 15.75 14.75C15.75 13.8562 16.0682 13.0911 16.7047 12.4547C17.3411 11.8182 18.1062 11.5 19 11.5C19.8937 11.5 20.6589 11.8182 21.2953 12.4547C21.9318 13.0911 22.25 13.8562 22.25 14.75C22.25 15.6437 21.9318 16.4089 21.2953 17.0453C20.6589 17.6818 19.8937 18 19 18ZM12.5 24.5V22.225C12.5 21.7646 12.6185 21.3414 12.8555 20.9555C13.0924 20.5695 13.4073 20.275 13.8 20.0719C14.6396 19.6521 15.4927 19.3372 16.3594 19.1273C17.226 18.9174 18.1062 18.8125 19 18.8125C19.8937 18.8125 20.774 18.9174 21.6406 19.1273C22.5073 19.3372 23.3604 19.6521 24.2 20.0719C24.5927 20.275 24.9076 20.5695 25.1445 20.9555C25.3815 21.3414 25.5 21.7646 25.5 22.225V24.5H12.5Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegistration);
export default __webpack_public_path__ + "static/media/icon-registration.61400cd1da4d4b05348d46a964bc81ed.svg";
export { ForwardRef as ReactComponent };